import { produce } from 'immer';
import { useCallback } from 'react';
import { usePanelStateAtom } from '../../hooks/rules-state';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { getCompRefType } from '../../utils/get-comp-ref-type';
export const useGlobalSectionState = () => {
  const {
    setGlobalSectionData,
    panelState
  } = usePanelStateAtom();
  const {
    a11yWizardAdapter,
    editorHost
  } = useA11yWizardAdapter();
  const getIsComponentInGlobalSection = useCallback(componentId => {
    let isGlobalComponent = false;
    try {
      isGlobalComponent = a11yWizardAdapter.getIsComponentInGlobalSection({
        id: componentId,
        type: getCompRefType(editorHost)
      });
    } catch (e) {
      console.error(`Error getting is component in global section for id: ${componentId}`, e);
    }
    return isGlobalComponent;
  }, [a11yWizardAdapter, editorHost]);
  const updateGlobalSectionStateIfNeeded = useCallback(data => {
    const newGlobalSectionData = produce(panelState.globalSectionComponentsDataMap ?? new Map(), draft => {
      data.forEach((partial, id) => {
        if (!getIsComponentInGlobalSection(partial.componentId)) {
          return;
        }
        draft.set(id, {
          ...(draft.get(id) ?? {}),
          ...partial
        });
      });
    });
    setGlobalSectionData(newGlobalSectionData);
    return newGlobalSectionData;
  }, [getIsComponentInGlobalSection, panelState.globalSectionComponentsDataMap, setGlobalSectionData]);
  const getGlobalSectionModifiedComponentIds = useCallback(updatedGlobalSectionDataMap => [...(Array.from((updatedGlobalSectionDataMap == null ? void 0 : updatedGlobalSectionDataMap.values()) ?? []).map(item => item.componentId) ?? [])], []);
  return {
    getGlobalSectionModifiedComponentIds,
    getIsComponentInGlobalSection,
    updateGlobalSectionStateIfNeeded
  };
};
//# sourceMappingURL=use-global-section-state.js.map